var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6667 6.16667L19.6729 4.36291C20.5982 3.8077 21.0609 3.5301 21.4416 3.56559C21.7735 3.59653 22.0764 3.768 22.2737 4.03672C22.5 4.34489 22.5 4.88444 22.5 5.96355V11.0364C22.5 12.1155 22.5 12.6551 22.2737 12.9633C22.0764 13.232 21.7735 13.4035 21.4416 13.4344C21.0609 13.4699 20.5982 13.1923 19.6729 12.6371L16.6667 10.8333M5.23333 15.5H12.9333C14.2401 15.5 14.8936 15.5 15.3927 15.2457C15.8317 15.022 16.1887 14.665 16.4123 14.226C16.6667 13.7269 16.6667 13.0734 16.6667 11.7667V5.23333C16.6667 3.92655 16.6667 3.27315 16.4123 2.77402C16.1887 2.33497 15.8317 1.97802 15.3927 1.75432C14.8936 1.5 14.2401 1.5 12.9333 1.5H5.23333C3.92655 1.5 3.27315 1.5 2.77402 1.75432C2.33497 1.97802 1.97802 2.33497 1.75432 2.77402C1.5 3.27315 1.5 3.92654 1.5 5.23333V11.7667C1.5 13.0734 1.5 13.7269 1.75432 14.226C1.97802 14.665 2.33497 15.022 2.77402 15.2457C3.27315 15.5 3.92654 15.5 5.23333 15.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/EventIcon.6d1209bbec2b25b08cead55ab85d1932.svg";
export { ForwardRef as ReactComponent };